<template>
  <div class="header_conntent">
    <div class="login_user_content">
      <div class="user_conten">
        <div v-if="vip_info.member_status == 1" style="margin-top: 10px">
          <div class="unlidernm" >
            <img class="lm" src="../../assets/shape.svg" alt="">
            <div class="mimner">{{$t('new_header.Unlimited')}}
              <span class="em">
                x{{vip_info.member_kids}}
              </span>
            </div>
          </div>
          <div class="expirestime">
            {{user.member_expire_show}}
          </div>
        </div>
        <el-popover
          placement="top"
          popper-class="popoverprice"
          trigger="hover"
          v-model="visible">
          <div>
             <div class="popitem">
               <div class="popitemone"><span class="popspan1">{{$t('Paid Credit')}} </span> <span class="popspan2">{{$t('Refundable')}} </span></div>
               <div class="popitemtwo"><img src="../../assets/Ellipse374.png" alt=""> <span>{{user.purchased_credit}}</span></div>
             </div>
             <div class="popitem">
               <div class="popitemone"><span class="popspan1">{{$t('Reward Credit')}} </span> <span class="popspan2">{{$t('Non-Refundable')}} </span></div>
               <div class="popitemtwo"><img src="../../assets/Ellipse374.png" alt=""> <span>{{user.reward_credit}}</span></div>
             </div>
             <div class="poplast"><span>{{$t('For more information please read')}}</span> <a href="/parent/#/service" target="_blank">用户协议</a></div>
          </div>
          <div class="jiner" slot="reference">
            <img class="simei" src="../../assets/Ellipse374.png" alt="">
            <div class="zidum">{{user.balance}} <span style="display: inline-block;margin-left: 12px;" v-if="user.account_expire_at">{{user.account_expire_at}}</span><span style="font-size: 14px;">到期</span></div>
            <!-- <div class="zidum" v-if="user.account_expire_at" style="margin-left: 12px;">{{user.account_expire_at}}到期</div> -->
          </div>
        </el-popover>

        <!-- <div class="jiner" slot="reference">
          <img class="simei" src="../../assets/Ellipse374.svg" alt="">
          <div class="zidum">{{user_data.credit_balance}}</div>
        </div>    -->
        <div class="use_content">
<!--          <img class="icon_user" src="../../assets/Ellipse384.svg" alt="">-->
          <div class="router_chilm">
            <el-dropdown @command="chenge_router" trigger="click">
              <span class="el-dropdown-link ziti">
                {{value1}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item" v-for="(item,index) in options" :key="index">{{ $i18n.locale=='en' ? item.label_en:item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>



            <!-- <el-select
              v-model="value1"
              @change="chenge_router"
              size="mini">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select> -->
        </div>
        <div class="log_out_content" @click="login_out"> <img class="lo_out_icon" src="../../assets/Logout.png" alt=""> {{$t('new_header.Log_out')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { setStore, getStore, keys, clearStore } from '@/store';
export default {
  inject:['reload'],
  data(){
    return{
      options: [{
          value: '/home/children/MonthyuStatement',
          label_en:  'Monthly Statement',
          label:  '月账单'
        },{
          value: '/home/children/MonthlyPassUser',
          label_en: 'Pass Information',
          label: '我的会员套餐'
        },  {
          value: '/home/children/Transaction',
          label_en: 'Transaction History',
          label: '支付/订单记录'
        }, {
          value: '/home/children/information',
          label_en: 'Profile',
          label: '用户中心'
        }],
        value1: '',
        user:[],
        vip_info:[],

        user_data:[],
        visible:false,

    }
  },

  async created(){
   await this.$http.get('/api/accounts?model=lessons').then((res) => {
          if (res.data.code == 200) {
            setStore(keys.userBalance,res.data.data)
          }
      })
    this.user = getStore(keys.userBalance);
    if(this.user.member_type==0){
      this.options.splice(1,1);
    }
    this.value1 = ' +'+getStore(keys.userProfile).country_code+' '+getStore(keys.userProfile).mobile;
    var sons = getStore(keys.userProfile);
    this.vip_info = sons;
    console.log(this.user.language)
  },
  computed:{
  },
  methods: {
    /**
     * 退出登录
     */
    login_out:function(){
        this.$http.post('/api/user/logout').then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.data,
              type: 'success'
            })
            clearStore();
            this.$router.push({ path: '/' })
          }
        })
    },
    /**+{{data.country_code}} {{data.mobile}}
     * 选择跳转页面进行跳转
     */
    chenge_router:function(val){
      // this.value1 = val.label+' ( +'+getStore(keys.userProfile).country_code+' '+getStore(keys.userProfile).mobile+')';
      // if(val.label.indexOf('会员套餐')>-1){
      //   return
      // }
      this.$router.push({ path: val.value })
      this.reload();

    },

    /**
     * 更新缓存数据
     */
    up:function(){
      var sons = getStore(keys.userProfile);
      this.user = getStore(keys.userBalance);
      this.vip_info = sons;
      this.value1 = ' (+'+getStore(keys.userProfile).country_code+' '+getStore(keys.userProfile).mobile+')';
    },

  },

}
</script>
<style lang="less" scoped>
    .header_conntent{
        width: 100%;
        height: 68px;
        //min-width: 1200px;
        border-bottom:1px solid #F4F4F4;
        display: flex;
        .login_content{
            width: 358px;
            height: 68px;
            background: #FCFCFF;
            .logo{
                margin-top: 19px;
                margin-left: 40px;
            }
        }
        .login_user_content{
          //background: #FFF8D0;
          background: linear-gradient(0deg, #FFCDAF, #FFCDAF), rgba(0, 0, 0, 0);
          height: 68px;
          border:0px solid red;
          flex:1;
          .user_conten{
            height: 65px;
            border:0px solid red;
            float: right;
            display: flex;
            align-items: center;
            .unlidernm{
              width: 150px;
              height: 37px;
              background: #FECE0C;
              border-radius: 18.0828px;
              //margin-top: 23px;
              display: flex;
              align-items: center;

              .lm{
                width:15.33px;
                height:11.5px;
                // margin-top:13px;
                margin-left: 13.22px;
              }
              .mimner{
                // width: 85px;
                // margin-top: 12px;
                margin-left: 10px;
                display: flex;
                font-size: 15px;
                align-items: center;
              }
              .em{
                display: inline-block;
                border: #000000 1px solid;
                width: 23px;
                height: 23px;
                border-radius:50%;
                text-align: center;
                background: #000;
                color:  #FFFFFF;
                line-height: 23px;
                margin-left: 10px;
                // padding-bottom: 2px;
              }
            }
            .expirestime{
              font-family: Sofia Pro-Regular;
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 25px;
              text-align: center;
              text-transform: capitalize;
              color: #B9B9B9;
            }
            .jiner{
              background-color: #FFDFCC;
              border-radius: 12px;
              color: #FF6E17;
              cursor: pointer;
              // width: 77px;
              padding: 9px;
              height: 37px;
              // border: 1px solid #F2F2F2;
              box-sizing: border-box;
              border-radius: 50px;
              //margin-top:23px;
              margin-left: 25px;
              display: flex;
              align-items: center;
              justify-content: center;
              .simei{
                width: 23px;
                height: 23px;
              }
              .zidum{
                font-family: Sofia Pro;
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                // color: #000000;
                margin-left: 4px;
              }
            }
            .use_content{
              // width: 320px;
              height: 37px;
              //margin-top:23px;
              margin-left: 25px;
              //background: #FFFFFF;
              //border: 1px solid #F2F2F2;
              box-sizing: border-box;
              border-radius: 50px;
              .icon_user{
                margin-top:8px;
                margin-left:10px;
                width:21px;
                height:21px;
                float: left;
              }
              /deep/ .el-select{
                float: left;
                margin-top:3px;
                // width:278px;
              }
              /deep/ .el-input__inner{
                font-family: Sofia Pro;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                color: #000000;
              }
              /deep/ .el-select .el-input.is-focus .el-input__inner{
                border:0px;
              }
              /deep/ .el-select,
              /deep/ .el-input,
              /deep/ .el-input__inner{
                // background-color:#08164D ;
                // color:#fff;
                border:0px;
                border-radius:0px;
                border:none;
                text-align: center;
              }
            }
            .log_out_content{
              //width: 138px;
              height: 37px;
              border:0px solid red;
              //margin-top: 23px;
              margin-left: 25px;
              margin-right: 38px;
              text-align: center;
              font-family: Sofia Pro;
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              //line-height: 37px;
              color: #000000;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
    }


.el-select-dropdown__item.hover{
  background: #ffffff !important;
  color: #4B69FE !important;
  font-weight: bold !important;
}
.lo_out_icon{
  //position: relative;
  //top: 6px;
  //left: -5px;
  width: 16px;
  height: 14px;
  margin-right: 8px;
}
.router_chilm{
  height:40px;
  border:0px solid red;
  float: left;
  line-height: 36px;
  // line-height: 35px;
  margin-right: 15px;
  margin-left: 7px;
  cursor: pointer;
}
.ziti{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #000000;
}
.el-dropdown-menu__item{
    font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #000000;
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
  background-color: #ffffff !important;
  color: #4B69FE !important;
}




</style>
<style lang="less">
 /*  金币金额下拉框 */
  .popoverprice{
      padding: 21px 25px;
      min-height: 196px;
      min-width: 233px;
      box-sizing: border-box;
      border-radius: 12px;
      background: var(--base-white, #FFF);
      box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.04), 0px 5px 24px 10px rgba(16, 24, 40, 0.10);
      .popitem{
        display: flex;
        align-items: center;
      }
      .popitem+.popitem{
        margin-top: 16px;
      }
      .popitemone{
        min-width: 126px;
        span{
          display: block;
          text-align: left;
        }
        .popspan1{
          color: #000;
          font-size: 16px;
          font-weight: 600;
          line-height: 25px;
          letter-spacing: -0.165px;
        }
        .popspan2{
          color: #787878;
          font-size: 12px;
          font-weight: 500;
          line-height: 20px;
          letter-spacing: -0.165px;
        }
      }
      .popitemtwo{
        border-radius: 19px;
        background: #ECECEC;
        min-width: 69px;
        width: 100%;
        display: flex;
        align-items: center;
        padding:  7px 6px;
        box-sizing: border-box;
        justify-content: center;
        img{
          width: 15px;
          height: 15px;
          margin-right: 7px;
        }
        span{
          display: inline-block;
          color: #000;
          font-size: 16px;
          font-weight: 500;
          letter-spacing: -0.165px;
        }
      }
      .poplast{
        width: 220px;
        margin: 30px auto 0;
        span{
          color: #909090;
          text-align: center;
          font-family: Poppins;
          font-size: 12px;
          font-weight: 400;
        }
        a{
          color: #016FD0;
          font-family: Poppins;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          text-decoration-line: underline;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue